import { Injectable } from "@angular/core";

import { BaseGetProvider, DataTransformationProtocol } from "@tendercuts/http";
import { CustomerEliteSubscription } from "@tendercuts/models";

import { HttpClient, HttpParams } from "@angular/common/http";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";

@Injectable({
  providedIn: "root",
})

export class EliteHistoryService extends BaseGetProvider<CustomerEliteSubscription>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endPointService: EndPoint,
  ) {
    super(http);
    this.delegate = this;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get isCachable(): boolean {
    return false;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get model(): typeof CustomerEliteSubscription {
    return CustomerEliteSubscription;
  }

  get endpoint(): string {
    return this.endPointService.eliteSubscriptionHistoryEndpoint();
  }

  getParams(customerId: string): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append('customer_id', customerId.toString());

    return params;
  }
}
